import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegisterComponent } from '../../Home/register/register';

interface TickerEntry {
  id: string;
  type: string;
  amount: string;
  status: 'Posted' | 'Draft';
}

@Component({
  selector: 'app-accounting-hero',
  standalone: true,
  imports: [CommonModule, RegisterComponent],
  templateUrl: './accounting-hero.html',
  styleUrls: ['./accounting-hero.css'],
})
export class AccountingHeroComponent {
  showRegister = false;
  accountingApp = [{ name: 'Accounting', image: 'images/webps/accounting.svg' }];

  readonly ticker: TickerEntry[] = [
    { id: 'JE-20260724-005', type: 'Payment Receipt', amount: 'PKR 600', status: 'Posted' },
    { id: 'JE-20260724-006', type: 'Cash Payment', amount: 'PKR 200', status: 'Posted' },
    { id: 'JE-20260724-009', type: 'Manual Entry', amount: 'PKR 100', status: 'Draft' },
    { id: 'JE-20260724-002', type: 'Sales Invoice', amount: 'PKR 500', status: 'Posted' },
    { id: 'JE-20260724-004', type: 'Purchase Invoice', amount: 'PKR 300', status: 'Posted' },
    { id: 'JE-20260724-008', type: 'Manual Entry', amount: 'PKR 1,500', status: 'Posted' },
  ];
}
